export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "weekly_pace_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rythme hebdomadaire"])},
        "avg_compliance_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conformité moyenne"])},
        "stores_below_label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Magasins sous ", _interpolate(_named("threshold")), " %"])},
        "stores_below_detail": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["sur ", _interpolate(_named("total")), " magasins"])},
        "total_reward_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gains"])}
      },
      "en": {
        "weekly_pace_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weekly pace"])},
        "avg_compliance_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average compliance"])},
        "stores_below_label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Stores below ", _interpolate(_named("threshold")), "%"])},
        "stores_below_detail": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["out of ", _interpolate(_named("total")), " stores"])},
        "total_reward_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rewards"])}
      }
    }
  })
}
